import { apiGet } from "./client";

export type DeskGlanceQueueMetric = {
  count: number;
  outstanding?: string;
};

export type DeskGlanceSalesToday = {
  /** Tax-incl recognized gross for company-local today — plan/44 */
  amount: string;
  /** Same formula for yesterday (expand vs-period). */
  yesterdayAmount: string;
  /** Oldest → newest, 7 company-local days ending today (sparkline). */
  last7: string[];
};

export type DeskGlanceLowStock = {
  count: number;
  threshold: string;
};

export type DeskGlance = {
  salesToday: DeskGlanceSalesToday | null;
  toCollect: DeskGlanceQueueMetric | null;
  toDeliver: DeskGlanceQueueMetric | null;
  toPay: DeskGlanceQueueMetric | null;
  toReceive: DeskGlanceQueueMetric | null;
  lowStock: DeskGlanceLowStock | null;
};

/** Owner glance aggregates — plan/44 */
export function fetchDeskGlance(companyRef: string, signal?: AbortSignal) {
  return apiGet<DeskGlance>(`/c/${companyRef}/desk/glance`, { signal });
}
